type EntityOption = {
	label: string;
	id: string;
};

export const GAME_OPTIONS: EntityOption[] = [
	{
		label: 'LUDO',
		id: 'ludo'
	},
	{
		label: 'Ninja',
		id: 'ninja'
	},
	{
		label: 'SNL',
		id: 'snlt'
	},
	{
		label: 'Turbo',
		id: 'turbo'
	},
	{
		label: 'TC',
		id: 'tc'
	},
	{
		label: 'Carrom',
		id: 'carrom'
	},
	{
		label: 'Ludo Supreme League',
		id: 'ludonx'
	},
	{
		label: 'HC',
		id: 'hc'
	}
];
